var map = {
	"./aside-icon-01.png": "0vlv",
	"./aside-icon-02.png": "xE0i",
	"./aside-icon-03.png": "aklT",
	"./aside-icon-04.png": "JLTj",
	"./aside-icon-05.png": "Y1nw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ho4";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/aside\-icon\-0.*\.png$
// module id = 6ho4
// module chunks = 75